import Vue from 'vue'
import Router from 'vue-router'
import Index from '../view/index/index'
import Video from '../view/video/index'
import Live from '../view/live/index'
import Buy from '../view/buy/index'
import Personal from '../view/personal/index'
import CourseDetail from '../view/live/detail'
import VideoDetail from '../view/video/detail'
import UserData from '../view/personal/userdata'
import EditData from '../view/personal/editdata'
import AboutUs from '../view/personal/aboutus'
import BindPhone from '../view/personal/bindphone'
import LogOut from '../view/personal/logout'
import Author from '../view/login/author'
import OnLive from '../view/onlive/index'
import OnLiveDetail from '../view/onlive/detail'
import LivePlayer from '../view/live/live'
import GetCoupons from '../view/coupons/getCoupons'
import MyCoupons from '../view/coupons/myCoupons'
import { Toast, Image, Row, Col, Tab, Tabs, Cell, CellGroup, PullRefresh, List, Field, Button   } from 'vant'

Vue.use(Router).use(Toast).use(Image).use(Row).use(Col).use(Tab).use(Tabs).use(Cell).use(CellGroup).use(PullRefresh).use(List).use(Field).use(Button)

export default new Router({
	mode:'history',
	routes: [
		{
		  path: '/',
		  name: 'Index',
		  component: Index
		},
		{
			path: '/video',
			name: 'Video',
			component: Video
		},
		{
			path: '/live',
			name: 'Live',
			component: Live
		},
		{
			path: '/buy',
			name: 'Buy',
			component: Buy
		},
		{
			path: '/personal',
			name: 'Personal',
			component: Personal
		},
		{
		  path: '/coursedetail',
		  name: 'CourseDetail',
		  component: CourseDetail
		} ,
		{
		  path: '/videodetail',
		  name: 'VideoDetail',
		  component: VideoDetail
		},
		{
		  path: '/userdata',
		  name: 'UserData',
		  component: UserData
		},
		{
		  path: '/editdata',
		  name: 'EditData',
		  component: EditData
		},
		{
		  path: '/aboutus',
		  name: 'AboutUs',
		  component: AboutUs
		},
		{
		  path: '/bindphone',
		  name: 'BindPhone',
		  component: BindPhone
		},
		{
		  path: '/author',
		  name: 'Author',
		  component: Author
		},
		{
		  path: '/onlive',
		  name: 'OnLive',
		  component: OnLive
		},
		{
		  path: '/onlivedetail',
		  name: 'OnLiveDetail',
		  component: OnLiveDetail
		},
		{
		  path: '/liveplayer',
		  name: 'LivePlayer',
		  component: LivePlayer
		},
		{
		  path: '/logout',
		  name: 'LogOut',
	      component: LogOut
		},
		{
		  path: '/getCoupons',
		  name: 'GetCoupons',
		  component: GetCoupons
		},
		{
			path: '/myCoupons',
			name: 'MyCoupons',
			component: MyCoupons
		}
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js